/* ══════════════════════════════════════════════════════════
   ORZO — warstwa zachowań motywu.

   Zasada: cała treść przychodzi z Liquida, JavaScript tylko
   ożywia to, co już stoi w HTML-u. Żaden element nie zależy
   od tego skryptu, żeby być czytelnym — filtry zwężają listę,
   która i tak jest cała wyrenderowana, godziny dopisują się
   do pasm, które i tak mają adres i telefon.

   Teksty biorą się z window.ORZO.t (layout/theme.liquid),
   więc tłumaczą się razem z resztą motywu.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.ORZO || {};
  var T = CFG.t || {};
  var LOCALE = CFG.locale || 'pl';

  var $ = function (id) { return document.getElementById(id); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  var txt = function (key, fallback) { return T[key] != null ? T[key] : (fallback || ''); };

  /* liczebniki — Intl zna reguły każdego języka, my dostarczamy formy */
  var PR = null;
  try { PR = new Intl.PluralRules(LOCALE); } catch (e) { PR = null; }
  function plural(n, forms) {
    if (!forms) return '';
    var cat = PR ? PR.select(n) : (n === 1 ? 'one' : 'other');
    return forms[cat] || forms.other || forms.many || forms.one || '';
  }

  var NF = null;
  try { NF = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 }); } catch (e) { NF = null; }
  function kwota(n) {
    var v = NF ? NF.format(Math.round(n)) : String(Math.round(n));
    return v + ' ' + (CFG.currency || '');
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* ── toast ────────────────────────────────────────────── */
  var toastT;
  function toast(msg) {
    var el = $('toast');
    if (!el) return;
    el.textContent = msg;
    el.dataset.o = '1';
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.dataset.o = '0'; }, 4200);
  }

  /* ══ belka ═════════════════════════════════════════════ */
  var bar = document.querySelector('.bar');
  if (bar) {
    var setBarH = function () {
      document.documentElement.style.setProperty(
        '--barh', Math.round(bar.getBoundingClientRect().height) + 'px');
    };
    setBarH();
    addEventListener('resize', setBarH);
    if (window.ResizeObserver) new ResizeObserver(setBarH).observe(bar);

    /* na stronie głównej belka jest przezroczysta nad zdjęciem, ale robi się
       nieprzezroczysta już po dwunastu pikselach — inaczej logo znika w bieli */
    var przezroczysta = document.body.classList.contains('template-index');
    var onScroll = function () {
      bar.dataset.s = (!przezroczysta || scrollY > 12) ? '1' : '0';
    };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── szuflada mobilna ─────────────────────────────────── */
  var drw = $('drw'), burg = $('burg'), drwx = $('drwx');
  var drawerReturnFocus = null, drawerOverflow = '';
  var drawerBackground = [];
  if (drw) drw.inert = true;
  function openDrw(o) {
    if (!drw || (drw.dataset.o === '1') === !!o) return;
    if (o) {
      drawerReturnFocus = document.activeElement;
      drawerOverflow = document.body.style.overflow;
      drawerBackground = Array.prototype.slice.call(document.body.children)
        .filter(function (el) { return el !== drw && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName); })
        .map(function (el) { return { el: el, inert: el.inert }; });
      drawerBackground.forEach(function (item) { item.el.inert = true; });
      document.body.style.overflow = 'hidden';
    }
    drw.dataset.o = o ? '1' : '0';
    drw.inert = !o;
    if (burg) burg.setAttribute('aria-expanded', String(!!o));
    if (o) {
      if (drwx) drwx.focus({ preventScroll: true });
    } else {
      drawerBackground.forEach(function (item) { item.el.inert = item.inert; });
      drawerBackground = [];
      document.body.style.overflow = drawerOverflow;
      if (drawerReturnFocus && drawerReturnFocus.isConnected) drawerReturnFocus.focus({ preventScroll: true });
    }
  }
  if (drw) drw.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || drw.dataset.o !== '1') return;
    var items = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]', drw)
      .filter(function (el) { return el.getClientRects().length && !el.closest('[hidden], [inert]'); });
    var first = items[0], last = items[items.length - 1];
    if (!first) return;
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  if (burg) burg.addEventListener('click', function () { openDrw(true); });
  if (drwx) drwx.addEventListener('click', function () { openDrw(false); });
  if (drw) drw.addEventListener('click', function (e) {
    if (e.target === drw || e.target.closest('a')) openDrw(false);
  });

  /* ── rozwijane menu ───────────────────────────────────── */
  var megaId = null, megaT;
  function closeMega() {
    megaId = null;
    clearTimeout(megaT);
    if (bar) bar.dataset.open = '0';
    $$('#megas .mega').forEach(function (m) { m.hidden = true; });
    $$('#nav [data-mega]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
  }
  function openMega(i) {
    if (megaId === i) return;
    megaId = i;
    clearTimeout(megaT);
    if (bar) bar.dataset.open = '1';
    $$('#megas .mega').forEach(function (m) { m.hidden = m.dataset.megap !== String(i); });
    $$('#nav [data-mega]').forEach(function (a) {
      a.setAttribute('aria-expanded', a.dataset.mega === String(i) ? 'true' : 'false');
    });
  }
  if (bar) {
    bar.addEventListener('pointerover', function (e) {
      var t = e.target.closest('[data-mega]');
      if (t) { openMega(t.dataset.mega); return; }
      if (!e.target.closest('#megas')) {
        clearTimeout(megaT);
        megaT = setTimeout(closeMega, 240);
      }
    });
    bar.addEventListener('pointerleave', function () {
      clearTimeout(megaT);
      megaT = setTimeout(closeMega, 240);
    });
    bar.addEventListener('pointerenter', function () { clearTimeout(megaT); });
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mega]');
      if (!t) return;
      /* dotyk: pierwszy tap rozwija, drugi wchodzi na stronę */
      if (matchMedia('(hover: none)').matches && megaId !== t.dataset.mega) {
        e.preventDefault();
        openMega(t.dataset.mega);
      }
    });
    bar.addEventListener('focusin', function (e) {
      var t = e.target.closest('[data-mega]');
      if (t) openMega(t.dataset.mega);
      else if (!e.target.closest('#megas')) closeMega();
    });
  }
  addEventListener('click', function (e) { if (!e.target.closest('.bar')) closeMega(); });
  /* przewijanie zamyka panel — inaczej wisi nad treścią, którą chcecie przeczytać */
  ['scroll', 'wheel', 'touchmove'].forEach(function (ev) {
    addEventListener(ev, function () { if (megaId !== null) closeMega(); }, { passive: true });
  });

  /* ── przełącznik języka ───────────────────────────────── */
  function closeLangs() {
    $$('.lgmenu').forEach(function (m) { m.hidden = true; });
    $$('[data-lgtoggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lgtoggle]');
    if (t) {
      var m = $('lgm-' + t.dataset.lgtoggle);
      if (!m) return;
      var otwarte = m.hidden;
      closeLangs();
      if (otwarte) { m.hidden = false; t.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if (!e.target.closest('.langs')) closeLangs();
  });
  addEventListener('scroll', closeLangs, { passive: true });

  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { openDrw(false); closeMega(); closeLangs(); }
  });

  /* ══ godziny otwarcia ══════════════════════════════════
     godziny_json w metaobiekcie lokalu:
     [{"dni":[1,2,3,4],"od":12,"do":23},{"dni":[5,6],"od":12,"do":24}]
     dni: 0 = niedziela. „do":24 znaczy północ.
     Liquid nie zna strefy czasowej gościa, więc liczy to przeglądarka.
     ═════════════════════════════════════════════════════ */
  function parseGodziny(el) {
    var raw = el && el.getAttribute('data-godziny');
    if (!raw) return [];
    try {
      var v = JSON.parse(raw);
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function dzisiaj(reguly, dow) {
    for (var i = 0; i < reguly.length; i++) {
      var r = reguly[i];
      if (r && r.dni && r.dni.indexOf(dow) !== -1) return r;
    }
    return null;
  }
  function stanOtwarcia(reguly, instant) {
    var now = instant || new Date();
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Warsaw', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now);
    var clock = {};
    parts.forEach(function (part) { clock[part.type] = part.value; });
    var mins = Number(clock.hour) * 60 + Number(clock.minute);
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(clock.weekday);
    var h = dzisiaj(reguly, day);
    if (!h) return { k: 'off', t: txt('closed_today') };
    if (mins < h.od * 60) return { k: 'off', t: txt('opens_at') + ' ' + pad2(h.od) + ':00' };
    if (mins >= h.do * 60) return { k: 'off', t: txt('closed') };
    if (h.do * 60 - mins <= 60) return { k: 'soon', t: txt('open_until') + ' ' + pad2(h.do % 24) + ':00' };
    return { k: 'on', t: txt('open_until') + ' ' + pad2(h.do % 24) + ':00' };
  }

  /* ── status otwarcia w innych miejscach ───────────────── */
  $$('.hr[data-godziny]').forEach(function (el) {
    var st = stanOtwarcia(parseGodziny(el));
    if (!st.t) return;
    el.textContent = st.t;
    el.className = 'hr ' + st.k;
  });

  /* ══ filtry karty dań ══════════════════════════════════ */
  (function () {
    var panel = $('filtry-karty'), lista = $('lista-dan');
    if (!panel || !lista) return;
    var pusto = $('brak-dan'), licznik = $('licznik-dan');
    var stan = { cat: 'all', diet: [] };

    function odswiez() {
      var widocznych = 0;
      $$('.row', lista).forEach(function (r) {
        var kat = r.getAttribute('data-cat') || '';
        var diety = (r.getAttribute('data-diet') || '').split(/\s+/);
        var ok = (stan.cat === 'all' || kat === stan.cat) &&
          stan.diet.every(function (d) { return diety.indexOf(d) !== -1; });
        r.hidden = !ok;
        if (ok) widocznych++;
      });
      if (licznik) licznik.textContent = widocznych + ' ' + plural(widocznych, T.items_forms);
      if (pusto) pusto.hidden = widocznych > 0;
      $$('[data-cat]', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.cat === stan.cat));
      });
      $$('[data-diet]', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', String(stan.diet.indexOf(b.dataset.diet) !== -1));
      });
    }

    panel.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cat]');
      if (c) { stan.cat = c.dataset.cat; odswiez(); return; }
      var d = e.target.closest('[data-diet]');
      if (d) {
        var v = d.dataset.diet;
        var i = stan.diet.indexOf(v);
        if (i === -1) stan.diet.push(v); else stan.diet.splice(i, 1);
        odswiez();
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-clearf]')) { stan.cat = 'all'; stan.diet = []; odswiez(); }
    });
    odswiez();
  }());

  /* ══ filtry karty baru ═════════════════════════════════ */
  (function () {
    var panel = $('filtry-baru'), lista = $('lista-baru');
    if (!panel || !lista) return;
    var licznik = $('licznik-baru');
    function odswiez(cat) {
      var n = 0;
      $$('.sp', lista).forEach(function (s) {
        var ok = cat === 'all' || s.getAttribute('data-bcat') === cat;
        s.hidden = !ok;
        if (ok) n++;
      });
      if (licznik) licznik.textContent = n + ' ' + plural(n, T.items_forms);
      $$('[data-bcat]', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.bcat === cat));
      });
    }
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bcat]');
      if (b) odswiez(b.dataset.bcat);
    });
    odswiez('all');
  }());

  /* ══ filtry sal ════════════════════════════════════════ */
  (function () {
    var panel = $('filtry-sal'), lista = $('lista-sal');
    if (!panel || !lista) return;
    var suwak = $('suwak-gosci'), wyjscie = $('liczba-gosci');
    var licznik = $('licznik-sal'), pusto = $('brak-sal');
    var stan = { gosci: suwak ? +suwak.value : 40, lok: 'all' };

    function odswiez() {
      var n = 0, wszystkich = 0;
      $$('.hall', lista).forEach(function (h) {
        wszystkich++;
        var poj = +(h.getAttribute('data-poj') || 0);
        var lok = h.getAttribute('data-lok') || '';
        var ok = (stan.lok === 'all' || lok === stan.lok) && (poj === 0 || poj >= stan.gosci);
        h.hidden = !ok;
        if (ok) n++;
      });
      if (wyjscie) wyjscie.textContent = stan.gosci;
      if (licznik) {
        licznik.textContent = (T.rooms_match || '{n}/{all}')
          .replace('{n}', n).replace('{all}', wszystkich);
      }
      if (pusto) pusto.hidden = n > 0;
      $$('[data-lok]', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.lok === stan.lok));
      });
    }

    if (suwak) suwak.addEventListener('input', function () {
      stan.gosci = +suwak.value;
      odswiez();
    });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lok]');
      if (b) { stan.lok = b.dataset.lok; odswiez(); }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-clearh]')) {
        stan.gosci = 40;
        stan.lok = 'all';
        if (suwak) suwak.value = 40;
        odswiez();
      }
    });
    odswiez();
  }());

  /* ══ kalkulator wydarzenia ═════════════════════════════ */
  (function () {
    var box = document.querySelector('.calc[data-sale]');
    if (!box) return;
    var sale = [];
    try { sale = JSON.parse(box.getAttribute('data-sale')) || []; } catch (e) { sale = []; }

    var sg = $('k-g'), sh = $('k-h');
    var wyjscieG = $('k-g-out'), wyjscieH = $('k-h-out');
    var suma = $('k-suma'), salaEl = $('k-sala'), nota = $('k-nota'), cta = $('k-cta');
    var bazoweCta = cta ? cta.getAttribute('href') || '' : '';

    function aktywny(sel) {
      return box.querySelector(sel + '[aria-pressed="true"]') || box.querySelector(sel);
    }
    function liczba(el, attr) {
      var v = el ? parseFloat(String(el.getAttribute(attr) || '').replace(',', '.')) : NaN;
      return isNaN(v) ? 0 : v;
    }

    function przelicz() {
      var g = sg ? +sg.value : 40;
      var h = sh ? +sh.value : 4;
      if (wyjscieG) wyjscieG.textContent = g;
      if (wyjscieH) wyjscieH.textContent = h;

      var typ = aktywny('[data-kt]');
      var menu = aktywny('[data-km]');
      var mnoznik = typ ? (liczba(typ, 'data-mnoznik') || 1) : 1;
      var stawka = menu ? liczba(menu, 'data-cena') : 0;

      var razem = stawka * g * mnoznik;
      razem += Math.max(0, h - 4) * stawka * g * 0.06;   /* każda godzina ponad cztery */
      $$('[data-ka][aria-pressed="true"]', box).forEach(function (d) {
        var c = liczba(d, 'data-cena');
        razem += d.getAttribute('data-na-osobe') === 'true' ? c * g : c;
      });

      if (suma) suma.textContent = stawka ? kwota(razem) : '—';

      /* najmniejsza sala, która pomieści tylu gości */
      var pasuje = sale
        .filter(function (s) { return s.p >= g; })
        .sort(function (a, b) { return a.p - b.p; })[0];
      if (salaEl) {
        if (pasuje) {
          salaEl.innerHTML = '';
          var a = document.createElement('a');
          a.href = pasuje.u || '#';
          a.textContent = pasuje.n + ' — ORZO ' + pasuje.l;
          salaEl.appendChild(a);
        } else {
          salaEl.textContent = txt('calc_no_room');
        }
      }
      if (nota) {
        nota.textContent = pasuje
          ? (T.calc_note || '').replace('{n}', pasuje.p)
          : txt('calc_note_none');
      }
      if (cta && bazoweCta) {
        var q = 'osoby=' + g + '&godziny=' + h +
          (typ ? '&typ=' + encodeURIComponent(typ.textContent.trim()) : '') +
          (pasuje ? '&sala=' + encodeURIComponent(pasuje.n) : '');
        cta.setAttribute('href', bazoweCta + (bazoweCta.indexOf('?') === -1 ? '?' : '&') + q);
      }
    }

    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kt]');
      if (t) {
        $$('[data-kt]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
        przelicz();
        return;
      }
      var m = e.target.closest('[data-km]');
      if (m) {
        $$('[data-km]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b === m)); });
        przelicz();
        return;
      }
      var d = e.target.closest('[data-ka]');
      if (d) {
        d.setAttribute('aria-pressed', d.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        przelicz();
      }
    });
    if (sg) sg.addEventListener('input', przelicz);
    if (sh) sh.addEventListener('input', przelicz);
    przelicz();
  }());

  /* ══ walidacja formularzy ══════════════════════════════
     Formularze idą przez {% form 'contact' %}, więc wysyłkę
     robi Shopify. My tylko nie pozwalamy wysłać pustego —
     błąd pokazuje się przy polu, nie w oknie alertu.
     ═════════════════════════════════════════════════════ */
  var cyfry = function (s) { return String(s || '').replace(/\D/g, '').length; };
  var mail = function (s) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(String(s || '').trim()); };
  var wartosc = function (f, id) { var el = $(id); return el ? String(el.value || '').trim() : ''; };

  function zlyWiersz(forma, nazwa) {
    var w = forma.querySelector('[data-f="' + nazwa + '"]');
    if (w) { w.dataset.bad = '1'; return w; }
    return null;
  }
  function sprawdz(forma, reguly) {
    $$('[data-bad="1"]', forma).forEach(function (x) { x.dataset.bad = '0'; });
    var pierwszy = null;
    reguly.forEach(function (r) {
      if (!r[1]()) {
        var w = zlyWiersz(forma, r[0]);
        if (!pierwszy) pierwszy = w;
      }
    });
    if (pierwszy) {
      var inp = pierwszy.querySelector('input,select,textarea');
      pierwszy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 300);
    }
    return !pierwszy;
  }

  document.addEventListener('input', function (e) {
    var w = e.target.closest('.fr');
    if (w && w.dataset.bad === '1') w.dataset.bad = '0';   /* błąd znika, gdy poprawiacie */
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;

    if (f.id === 'f-rez') {
      var godzina = $('pole-godzina');
      if (godzina && !godzina.value) { e.preventDefault(); toast(txt('err_hour')); return; }
      var okRez = sprawdz(f, [
        ['imie', function () { return wartosc(f, 'r-imie').length >= 2; }],
        ['tel', function () { return cyfry(wartosc(f, 'r-tel')) >= 9; }],
        ['zgoda', function () { var z = $('r-zg'); return z && z.checked; }]
      ]);
      if (!okRez) e.preventDefault();
      return;
    }

    if (f.id === 'f-kon') {
      var okKon = sprawdz(f, [
        ['imie', function () { return wartosc(f, 'k-imie').length >= 2; }],
        ['mail', function () { return mail(wartosc(f, 'k-mail')); }],
        ['tel', function () { var v = wartosc(f, 'k-tel'); return !v || cyfry(v) >= 9; }],
        ['tresc', function () { return wartosc(f, 'k-tr').length >= 10; }],
        ['zgoda', function () { var z = $('k-zg'); return z && z.checked; }]
      ]);
      if (!okKon) e.preventDefault();
    }
  });

  /* ── potwierdzenia po powrocie z Shopify ──────────────── */
  if (document.querySelector('.done')) {
    var d = document.querySelector('.done h2');
    if (d) toast(d.textContent.trim());
  }
}());
